import { FollowStyled } from "./Modals/styles"



export const ModalFollow = ({ title, children }: any) => {

    return (
        <FollowStyled>
            <h3>{title}</h3>
            <div className="follow-container">
                {children}
            </div>
        </FollowStyled>
    )
}